export default __webpack_public_path__ + "static/media/central_andes_2_4.135d9956.JPG";